import { useEffect, useState } from 'react';

/**
 * Render HTML in an isolated iframe (blob: URL).
 * Avoids srcDoc + allow-same-origin, which loads the parent React app at about:srcdoc.
 */
export default function ReportHtmlFrame({ html, title, className = 'w-full h-full border-0' }) {
  const [src, setSrc] = useState('');

  useEffect(() => {
    if (!html) {
      setSrc('');
      return undefined;
    }
    const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    setSrc(url);
    return () => URL.revokeObjectURL(url);
  }, [html]);

  if (!src) return null;

  return (
    <iframe
      src={src}
      title={title || 'Report'}
      className={className}
      sandbox="allow-scripts allow-forms allow-popups"
    />
  );
}
